module.exports = __webpack_public_path__ + "media/images/logo__ironheadsgc-672af95edc7fbfd7657fdfdd6fa4863e.png";